/* eslint-disable react/forbid-elements */
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PureComponent } from 'react';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { HOME_TAB } from 'Component/NavigationTabs/NavigationTabs.config';

import './YBFraseHead.style';

/** @namespace Elganso/Component/YBFraseHead/Component */
export class YBFraseHeadComponent extends PureComponent {
    getStilosFormat(estilo) {
        const regex = /([\w-]*)\s*:\s*([^;]*)/g;
        let match; const
            properties = {};

        // eslint-disable-next-line no-cond-assign
        while (match = regex.exec(estilo)) {
            properties[match[1].replace(/-./g, (x) => x[1].toUpperCase())] = match[2].trim();
        }

        return properties;
    }

    showFraseHead(fraseHead) {
        if (fraseHead) {
            const {
                cerradoManual,
                navigationState: { name }
            } = this.props;

            const {
                enabled,
                mostrarsoloenhome
            } = fraseHead;

            if (cerradoManual || !enabled) {
                return false;
            }

            if (mostrarsoloenhome) {
                if (name === HOME_TAB || name === 'default') {
                    return true;
                }

                return false;
            }

            return true;
        }

        return false;
    }

    render() {
        const {
            closeFraseHead, fraseHeadConfig, device: { isMobile }
        } = this.props;

        let fraseHead = null;

        if (fraseHeadConfig && 'enabled' in fraseHeadConfig) {
            const {
                enabled,
                texto_1,
                link_1,
                texto_2,
                link_2,
                texto_3,
                link_3,
                texto_mobile_1,
                link_mobile_1,
                texto_mobile_2,
                link_mobile_2,
                texto_mobile_3,
                link_mobile_3,
                segundos_slider,
                abrirennuevapest,
                mostrarsoloenhome,
                backgoundfondo,
                backgoundfondo_movil,
                colortexto,
                colortexto_movil,
                fuente,
                estiloadicionalbloque,
                estiloadicionalenlace
            } = fraseHeadConfig;

            fraseHead = {
                enabled,
                texto_1,
                link_1,
                texto_2,
                link_2,
                texto_3,
                link_3,
                segundos_slider,
                abrirennuevapest,
                mostrarsoloenhome,
                backgroundfondo: backgoundfondo,
                colortexto,
                fuente,
                estiloadicionalbloque,
                estiloadicionalenlace
            };

            if (isMobile) {
                fraseHead = {
                    enabled,
                    texto_1: texto_mobile_1,
                    link_1: link_mobile_1,
                    texto_2: texto_mobile_2,
                    link_2: link_mobile_2,
                    texto_3: texto_mobile_3,
                    link_3: link_mobile_3,
                    segundos_slider,
                    abrirennuevapest,
                    mostrarsoloenhome,
                    backgroundfondo: backgoundfondo_movil,
                    colortexto: colortexto_movil,
                    fuente,
                    estiloadicionalbloque,
                    estiloadicionalenlace
                };
            }
        }

        if (this.showFraseHead(fraseHead) && fraseHead !== null) {
            let nuevaPestaña = '';

            if (fraseHead.abrirennuevapest) {
                nuevaPestaña = '_blank';
            }

            const style = {
                backgroundColor: fraseHead.backgroundfondo,
                color: fraseHead.colortexto,
                fontFamily: fraseHead.fuente
            };

            const styleClose = {
                '--close-icon-color': fraseHead.colortexto
            };

            const estiloAdicionalEnlace = `${fraseHead.estiloadicionalenlace}`;

            const styleAdicionalEnlace = { ...style, ...this.getStilosFormat(estiloAdicionalEnlace) };

            const stilo = `${fraseHead.estiloadicionalbloque}`;

            const properties = this.getStilosFormat(stilo);

            const merged = { ...style, ...properties };

            return (
                <div
                  block="YBFraseHead"
                  style={ merged }
                >
                    <Swiper
                      speed={ 400 }
                      spaceBetween={ 100 }
                      init
                      loop
                      autoplay={ { delay: fraseHead.segundos_slider * 1000 } }
                      effect="fade"
                      fadeEffect={ { crossFade: true } }
                      modules={ [Autoplay] }
                    >
                        { (fraseHead.texto_1 && fraseHead.texto_1 !== '')
                            ? (
                            <SwiperSlide key="frase1">
                                { (fraseHead.link_1 && fraseHead.link_1 !== '') ? (
                                    <a href={ fraseHead.link_1 } style={ styleAdicionalEnlace } target={ nuevaPestaña }>
                                        { fraseHead.texto_1 }
                                    </a>
                                ) : (
                                    fraseHead.texto_1
                                ) }
                            </SwiperSlide>
                            )
                            : '' }
                        { (fraseHead.texto_2 && fraseHead.texto_2 !== '')
                            ? (
                            <SwiperSlide key="frase2">
                                { (fraseHead.link_2 && fraseHead.link_2 !== '') ? (
                                    <a href={ fraseHead.link_2 } style={ styleAdicionalEnlace } target={ nuevaPestaña }>
                                        { fraseHead.texto_2 }
                                    </a>
                                ) : (
                                    fraseHead.texto_2
                                ) }
                            </SwiperSlide>
                            )
                            : '' }
                        { (fraseHead.texto_3 && fraseHead.texto_3 !== '')
                            ? (
                            <SwiperSlide key="frase3">
                                { (fraseHead.link_3 && fraseHead.link_3 !== '') ? (
                                    <a href={ fraseHead.link_3 } style={ styleAdicionalEnlace } target={ nuevaPestaña }>
                                        { fraseHead.texto_3 }
                                    </a>
                                ) : (
                                    fraseHead.texto_3
                                ) }
                            </SwiperSlide>
                            )
                            : '' }
                    </Swiper>
                    <span
                      className="botonCerrar"
                      onClick={ closeFraseHead }
                      onKeyUp={ () => {} }
                    >
                        <FontAwesomeIcon
                          className="faXmark"
                          icon={ faXmark }
                          style={ styleClose }
                        />

                    </span>

                </div>
            );
        }

        return (
            <> </>
        );
    }
}

export default YBFraseHeadComponent;
